import { Loading } from "@podtrac/common/components/Loading";
import axios from "axios";
import { Field, Formik } from "formik";
import { useSearchParams } from "react-router-dom";
import { useFeedSearch } from "../api/feed-search";
import { useRegister } from "../api/register";
import { FeedResult } from "./Host";
import { useState } from "react";

export default function Account() {
    const [error, setError] = useState();
    const [searchParams, setSearchParams] = useSearchParams();
    const url = searchParams.get("url");
    const query = searchParams.get("q");
    const f = useFeedSearch(query, url),
        { isLoading: feedLoading, data: { found = [] } = {} } = f,
        feed = found[0];

    const r = useRegister({
            onSuccess: ({ accountID }) => (window.location = `/dashboard/${accountID}`),
            onError: error =>
                setError(
                    error?.response?.data?.ExceptionMessage == "Attempting to steal a show"
                        ? "registered"
                        : "other"
                )
        }),
        { mutate: register } = r;

    const validate = values => {
        const errors = {};

        if (!values.accountName) {
            errors.accountName = "Required";
        } else if (values.accountName.length > 50) {
            errors.accountName = "Must be 50 characters or less";
        }

        if (!values.name) {
            errors.name = "Required";
        } else if (values.name.length > 100) {
            errors.name = "Must be 100 characters or less";
        }

        if (!values.email) {
            errors.email = "Required";
        } else if (values.email.length > 255) {
            errors.email = "Must be 255 characters or less";
        }

        if (!values.password) {
            errors.password = "Required";
        } else if (values.password.length < 8) {
            errors.password = "Must be at least 8 characters";
        }

        return errors;
    };

    const emailAvailable = async email => {
        const response = await axios.get("/api/register/email-available", { params: { email } });
        return response.data ? null : "Email address is already registered";
    };

    return (
        <>
            <h1>Create an Account to Register Your Show with Podtrac</h1>
            {feedLoading ? <Loading /> : feed ? <FeedResult feed={feed} /> : <p>Feed not found.</p>}

            {error ? (
                error == "registered" ? (
                    <>
                        <h2>Already Registered</h2>
                        <p>This show is already registered in an existing Podtrac account.</p>
                        <p>
                            Email <a href="mailto:support@podtrac.com">support@podtrac.com</a> with
                            the RSS URL and show name for assistance.
                        </p>
                    </>
                ) : (
                    <>
                        <h2>Error</h2>
                        <p>An error occured during registration.</p>
                        <p>
                            Email <a href="mailto:support@podtrac.com">support@podtrac.com</a> with
                            the RSS URL and show name for assistance.
                        </p>
                    </>
                )
            ) : (
                <Formik
                    initialValues={{
                        accountName: "",
                        name: "",
                        email: "",
                        password: ""
                    }}
                    onSubmit={async values => {
                        await register({
                            ...values,
                            showTitle: feed.title,
                            feedUrl: url
                        });
                    }}
                    validate={validate}
                    validateOnChange={false}
                >
                    {formik => (
                        <form onSubmit={formik.handleSubmit} className="form">
                            <label className="label">Company/Organization:</label>
                            <div className="field">
                                <input
                                    type="text"
                                    id="accountName"
                                    name="accountName"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.accountName}
                                    className={
                                        formik.touched.accountName && formik.errors.accountName
                                            ? "error"
                                            : null
                                    }
                                />
                                {formik.touched.accountName && formik.errors.accountName ? (
                                    <div className="error">{formik.errors.accountName}</div>
                                ) : (
                                    <div className="info">
                                        The name displayed on the dashboard for this account
                                    </div>
                                )}
                            </div>
                            <label className="label">Name:</label>
                            <div className="field">
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}
                                    className={
                                        formik.touched.name && formik.errors.name ? "error" : null
                                    }
                                />
                                {formik.touched.name && formik.errors.name ? (
                                    <div className="error">{formik.errors.name}</div>
                                ) : (
                                    <div className="info">Your full name</div>
                                )}
                            </div>
                            <label className="label">Email:</label>
                            <div className="field">
                                <Field
                                    type="email"
                                    name="email"
                                    className={
                                        formik.touched.email && formik.errors.email ? "error" : null
                                    }
                                    validate={emailAvailable}
                                />
                                {formik.touched.email && formik.errors.email ? (
                                    <div className="error">{formik.errors.email}</div>
                                ) : (
                                    <div className="info">Your email address</div>
                                )}
                            </div>
                            <label className="label">Password:</label>
                            <div className="field">
                                <input
                                    type="password"
                                    name="password"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.password}
                                    className={
                                        formik.touched.password && formik.errors.password
                                            ? "error"
                                            : null
                                    }
                                />
                                {formik.touched.password && formik.errors.password ? (
                                    <div className="error">{formik.errors.password}</div>
                                ) : (
                                    <div className="info">{"\u2001"}</div>
                                )}
                            </div>
                            <input type="hidden" name="showTitle" defaultValue={feed?.title} />
                            <input type="hidden" name="feedUrl" defaultValue={url} />

                            <div className="buttons">
                                <button type="submit" disabled={formik.isSubmitting}>
                                    Create Account
                                </button>
                            </div>
                        </form>
                    )}
                </Formik>
            )}
            {/*<pre
                style={{ marginTop: "100vh", background: "#eee", padding: "1em", overflow: "auto" }}
            >
                {JSON.stringify({ r, url, f }, null, 2)}
            </pre>*/}
        </>
    );
}
